import { jsonMember, jsonObject } from 'typedjson';
import { PublicAvailability } from '../../enums/public-availability';

@jsonObject
export class PublicCartItemStatusResponse {
  @jsonMember(String)
  public readonly availability!: PublicAvailability;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder!: number;

  @jsonMember(String)
  public readonly unavailableMessage!: string;
}
